import { css } from 'styled-components';

const styles = css`
  &.container {
    display: flex;
    width: 464px;
    justify-content: flex-start !important;
    padding: ${({ theme }) =>
      `${theme.spacing.ELEM_SPACING.XS} ${theme.spacing.ELEM_SPACING.XS} ${theme.spacing.ELEM_SPACING.SM} ${theme.spacing.ELEM_SPACING.SM}`};
    border-radius: 12px;
    border: 1px solid ${({ theme }) => theme.colors.PRIMARY.LIGHTGRAY};
    background-color: ${({ theme }) => theme.colors.WHITE};
    flex-direction: row;
    box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.2);
    z-index: 1100;
    position: fixed;
    top: 112px;
    right: 12px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      width: 94%;
      top: 32px;
      right: 1px;
    }

    transform: translate(0, -50%);

    .header-text {
      color: ${({ theme }) => theme.colors.PRIMARY.DARK};
      font-family: ${({ theme }) => theme.fonts.secondaryFontFamily};
      font-size: ${({ theme }) => theme.fonts.fontSize.body.bodytext.copy3}px;
      font-weight: ${({ theme }) => theme.fonts.fontWeight.medium};
    }

    .link-cls {
      color: ${({ theme }) => theme.colors.BUTTON.BLUE.LEFT_FILTERS_BTN};
      font-family: ${({ theme }) => theme.fonts.secondaryFontFamily};
      font-size: ${({ theme }) => theme.fonts.fontSize.body.bodytext.copy3}px;
      font-weight: ${({ theme }) => theme.fonts.fontWeight.bold};
      text-decoration-line: underline;
    }
    .icon-wrapper {
      display: flex;
      padding-top: ${({ theme }) => theme.spacing.ELEM_SPACING.XXS};
      margin-right: ${({ theme }) => theme.spacing.ELEM_SPACING.SM};
      align-items: center;
      align-self: stretch;
    }
  }
`;

export default styles;
